import { css } from "@stubhub/broadway-foundation/css";

// Gradient blob via Modal classes.content ::before — covers full card including header
export const modalCardClass = css({
  position: "relative",
  overflowX: "hidden",
  overflowY: "hidden",
  "&::before": {
    content: "['']",
    position: "absolute",
    width: "[62.4%]",
    height: "[640px]",
    insetInlineStart: "[18.8%]",
    insetBlockStart: "[-280px]",
    backgroundImage:
      "[conic-gradient(from 180deg at 50% 50%, rgba(94,41,186,0.20) 0deg, rgba(221,30,117,0.20) 180deg, rgba(94,41,186,0.20) 360deg)]",
    opacity: "[0.6]",
    filter: "[blur(50px)]",
    transform: "[rotate(-71.733deg)]",
    pointerEvents: "none",
    zIndex: "[0]",
  },
});

// Body — z-index:1 to render above ::before gradient
export const bodyStyle = css({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  columnGap: "[12px]",
  rowGap: "[12px]",
  width: "full",
  textAlign: "center",
  zIndex: "[1]",
});

// Wrapper for rating group + label — no gap between them
export const ratingGroupWrapperStyle = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

// Rating group container — Figma: 158×100px
export const ratingGroupStyle = css({
  position: "relative",
  height: "[100px]",
  width: "[158px]",
  zIndex: "[1]",
});

// Rating card — Figma: 81×81px, rotation -4deg, lavender bg, top: 10px
export const ratingCardStyle = css({
  position: "absolute",
  insetInlineStart: "[0]",
  insetBlockStart: "[10px]",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "[2px]",
  rowGap: "[2px]",
  backgroundColor: "[#F7EDFF]",
  borderStartStartRadius: "[12.93px]",
  borderStartEndRadius: "[12.93px]",
  borderEndEndRadius: "[12.93px]",
  borderEndStartRadius: "[12.93px]",
  paddingBlockStart: "[10px]",
  paddingInlineEnd: "[10px]",
  paddingBlockEnd: "[10px]",
  paddingInlineStart: "[10px]",
  boxShadow: "[0px 6.46px 17.23px rgba(0,0,0,0.07)]",
  transform: "[rotate(-4deg)]",
  width: "[81px]",
  height: "[81px]",
});

// App icon — 81×81px, top: 0, rotation baked into SVG
export const appIconStyle = css({
  position: "absolute",
  insetInlineEnd: "[0]",
  insetBlockStart: "[0]",
  width: "[81px]",
  height: "[81px]",
  borderStartStartRadius: "[12px]",
  borderStartEndRadius: "[12px]",
  borderEndEndRadius: "[12px]",
  borderEndStartRadius: "[12px]",
  objectFit: "cover",
  zIndex: "[1]",
});

// "4.8" — SemiBold 24px, purple
export const ratingScoreStyle = css({
  fontWeight: "[600]",
  fontSize: "[24px]",
  lineHeight: "[1]",
  color: "[#5E29BA]",
});

export const ratingStarsStyle = css({
  display: "flex",
  flexDirection: "row",
  columnGap: "[1px]",
  rowGap: "[1px]",
  color: "[#5E29BA]",
});

// "1.4m+ App Store Ratings" — Inter Medium 12px
export const ratingLabelStyle = css({
  fontSize: "[12px]",
  lineHeight: "[16px]",
  fontWeight: "[500]",
  color: "[#5E29BA]",
  textAlign: "center",
});

// Headline — override Broadway Heading default font-size to match Figma 20px/24px
export const headingStyle = css({
  width: "[284px]",
  fontSize: "[20px]",
  lineHeight: "[24px]",
});

// Footer — "Or download from" + store badges
export const footerStyle = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  columnGap: "[4px]",
  rowGap: "[4px]",
  width: "full",
});

export const orDividerStyle = css({
  fontSize: "[12px]",
  lineHeight: "[16px]",
  fontWeight: "[500]",
  color: "[#090C18]",
  textAlign: "center",
});

export const storeBadgesRowStyle = css({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "[8px]",
  rowGap: "[8px]",
});
